jQuery(document).foundation();

var parallax, parallaxSelector;
jQuery(document).ready(function(){
    // I get selector for main slider
    var owlSlider = jQuery(".main-slider");

    owlSlider.on('initialized.owl.carousel', function(event) {
        // I need to wait with initialization of Parralax to the moment where css transforms are finished
        setTimeout(function() {
            parallaxSelector = jQuery('.owl-item.active .scene')[0];
            // I need this additional class to disable tranisiton for transform when parallax is on
            jQuery(parallaxSelector).addClass('parallax-launched');
            parallax = new Parallax(parallaxSelector);
        }, 820);
    })

    // starting the main carousel, with cool lazy load
    owlSlider.owlCarousel({
        items: 1,
        nav: true,
        loop: true,
        lazyLoad: true,
        autoplay: true,
        autoplayTimeout: 6500
    });

    // when this events occurs it means that somebody change slide, so  I need
    // to stop calculating things for current slider and do parallax on new slider
    owlSlider.on('translated.owl.carousel', function(event) {
        parallax.disable();
        jQuery(parallaxSelector).removeClass('parallax-launched');
        // reseting the positing, to avoid freaking out of position
        jQuery(parallaxSelector).find('.layer').css("transform", "translate3d(0px, 0px, 0px)");
        // I'm waiting with starting parallax effect to end of css animation on slider translation
        setTimeout(function() {
            // I update object 
            parallaxSelector = jQuery('.owl-item.active .scene')[0];
            // I need this additional class to disable tranisiton for transform when parallax is on
            jQuery(parallaxSelector).addClass('parallax-launched');
            parallax = new Parallax(parallaxSelector);
        }, 820);

    })
    
    var scene = document.getElementById('slider-background-helper');
    if(scene != null) {
        var parallax = new Parallax(scene);
    }
});